export default {
    apiUrl    : 'https://api.futureproof.app',
    apiPrefix : '/',
    amplitudeApiKey: '34d9b3efc474a0c13b2c8844278dc59b',
    amplitudeServerUrl: 'https://a.futureproof.app/2/httpapi',
    growthBookClientKey: 'sdk-6z73VOHX1UewKy',
    growthBookApiHost: 'https://cdn.growthbook.io',
    environment: 'production',
    platformUrl: 'https://futureproof.app',
    sisterWebsiteUrl: 'https://prelander.boundly.com'
};
